import Rating from "@JohnLewisPartnership/jl-design-system/dist/components/rating/Rating";
import { CardComponentProps } from "@~/types/types";
import { PDPLink } from "../__shared__/PDPLink/PDPLink";
import { SuffixType } from "@JohnLewisPartnership/jl-design-system/dist/components/rating/Rating.types";

export const Ratings = ({
  product,
  configProps,
}: Pick<CardComponentProps, "product" | "configProps">) => {
  if (!product.reviewSummary || !product.reviewSummary.numberOfReviews) {
    return null;
  }

  const suffixType = (configProps?.suffixType || "count") as SuffixType;

  return (
    <PDPLink product={product} componentName="Ratings" tabIndex={-1}>
      <Rating
        size="large"
        suffixType={suffixType}
        rating={{
          averageRating: product.reviewSummary.averageRating,
          reviews: product.reviewSummary.numberOfReviews,
        }}
      />
    </PDPLink>
  );
};
